import http from '@/services/http'
import router from '@/router'
import { removeUserErrorStatuses } from '@/const'
import * as Sentry from '@sentry/vue';

export default {
  namespaced: true,
  state: {
    user: null
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
    },
    REMOVE_USER_MANUFACTURE(state) {
      localStorage.removeItem('selectedManufacture')
      if (state.user) {
        state.user.manufacture = null
      }
    }
  },
  actions: {
    async login({ dispatch }, data) {
      const res = await http.post('auth', data)
      localStorage.setItem('token', res.token)
      await dispatch('fetchProfile')
    },

    async fetchProfile({ commit }) {
      const profile = await http.get('profile')
      Sentry.setUser(profile);
      commit('SET_USER', profile)
    },
    
    async logout({ dispatch }) {
      const token = localStorage.getItem('token')
      if (token) {
        try {
          await http.get('logout')
          dispatch('removeUser')
        } catch(e) {
          if (e.data) {
            const errCode = e.data.code
            if (removeUserErrorStatuses.includes(errCode)) {
              dispatch('removeUser')
            } else {
              throw e
            }
          } else {
            throw e
          }
        }
      } else {
        dispatch('removeUser')
      }
      
    },
    async removeUser({ commit }) {
      localStorage.removeItem('token')
      commit('SET_USER', null)
      commit('REMOVE_USER_MANUFACTURE')
      if (router.currentRoute.name !== 'auth') {
        router.push({ name: 'auth' })
      }
    },
    async getWelcomeScreen({ commit }) {
      try {
        commit('pageLoader/SET_LOADING', true, { root: true })
        const res = await http.get('welcome_screen')
        return res
      } finally {
        commit('pageLoader/SET_LOADING', false, { root: true })
      }
    },
    /** 
     * @param {*} manufactureId - передается из родительского компонента
     */
    async getExchange({ commit }, manufactureId) {
      try {
        commit('pageLoader/SET_LOADING', true, { root: true })
        return http.get(`manufacture/${manufactureId}/exchange`)
      } finally {
        commit('pageLoader/SET_LOADING', false, { root: true })
      }
      
    },
    startShift({ rootState }, exchange_cash_in_stock) {
      const manufactureId = rootState.manufactures.selectedManufacture.id
      return http.post(`admin_shift/${manufactureId}/start`, {
        exchange_cash_in_stock
      })
    },
    async fixateShift({ state, commit }) {
      if (state.user.role === 'admin') {
        try {
          commit('pageLoader/SET_LOADING', true, { root: true })
          const res = await http.post('admin_shift/fixate')
          commit('encashment/SET_FINAL_ENCASHMENT_DATA', res, { root: true })
          
        } finally {
          commit('pageLoader/SET_LOADING', false, { root: true })
        }
      }
    },
    async updloadPhoto({ commit, dispatch }, formData) {
      try {
        commit('pageLoader/SET_LOADING', true, { root: true })
        await http.post('profile/photo', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        await dispatch('fetchProfile')
      } finally {
        commit('pageLoader/SET_LOADING', false, { root: true })
      }
    }
  }
}
